/**
 * Sanitize a user-provided project name into a safe folder name.
 * Shared across Electron and web — keep in sync with web/sandbox/provider-env.ts.
 */
export function sanitizeProjectFolderName(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    || "starter";
}
